import React from 'react';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalContainer } from 'src/components/core';
import { LoyaltyPassAddToWallet } from 'src/components/loyalty-pass/loyalty-pass-add-to-wallet';
import { ModalComponentProps, withModalControlsHook } from 'src/components/modals/with-modal-controls-hook';

export type LoyaltyPassModalData = {
  url: string;
  width?: string;
  headerText?: string;
  closeButtonText?: string;
  qrCodeSize?: number;
  includeIconRow?: boolean;
};

const LoyaltyPassModal = ({
  onClose,
  containerProps,
  data,
}: ModalComponentProps<LoyaltyPassModalData>): JSX.Element => {
  const { url, width = '438px', headerText, closeButtonText, qrCodeSize, includeIconRow } = data;

  return (
    <ModalWrapper
      open
      role='dialog'
      aria-modal='true'
      aria-labelledby='loyalty-pass-title'
      aria-describedby='loyalty-pass-instructions'
    >
      <ModalContainer width={width} p='32px' {...containerProps}>
        <LoyaltyPassAddToWallet
          url={url}
          onClose={onClose}
          headerText={headerText}
          closeButtonText={closeButtonText}
          qrCodeSize={qrCodeSize}
          includeIconRow={includeIconRow}
        />
      </ModalContainer>
    </ModalWrapper>
  );
};

const [LoyaltyPassController, useLoyaltyPassModal] = withModalControlsHook<LoyaltyPassModalData>(LoyaltyPassModal);

export { useLoyaltyPassModal, LoyaltyPassController };
